import { useState } from 'react';

import cx from 'classnames';

import { PostBookingSurveyAnyCategory } from 'types/post-booking-survey';

import s from './PostBookingSurveyForm.module.css';

type Props = {
  answer: string;
  category: PostBookingSurveyAnyCategory;
  onChange: (answer: string) => void;
};

export const PostBookingSurveyCategory = ({
  answer,
  category,
  onChange,
}: Props) => {
  const [text, setText] = useState('');

  function onChangeText(value: string) {
    setText(value);
    onChange(value);
  }

  if (category.type === 'select') {
    return (
      <>
        {category.options.map((o, i) => (
          <button
            key={i}
            type="button"
            className={cx(s.selectButton, o === answer && s.active)}
            onClick={() => onChange(o)}
          >
            {o}
          </button>
        ))}
      </>
    );
  }

  if (category.type === 'text') {
    return (
      <>
        <input
          type="text"
          maxLength={50}
          value={text}
          placeholder={category.placeholder}
          onChange={(e) => onChangeText(e.target.value)}
        />
      </>
    );
  }

  return <></>;
};
